<template>
  <div>
    <!-- NEW PASSWORD -->
    <p v-if="isRegister" class="input-filter-label">{{ $lang.messages.password }}</p>
    <p v-else class="input-filter-label">{{ $lang.messages.newPassword }}</p>
    
    <div
        class="input-wrapper input-field"
        :class="{'error-input' : errors.has('password')}"
      >
        <input
          type="password"
          name="password"
          ref="password"
          class="input"
          :placeholder="$lang.messages.enterPassword"
          :value="passwordProp"
          v-validate="{
            required: true,
            regex: /^(?=.*?[a-z])(?=.*?[0-9]).{8,64}$/
          }"
          @input="updatePass"
          @focus.self="clearInputErrorsPass"
          @blur="clearOthersPass"
          @keypress="MX_capsLockHandler($event)"
          autocomplete="new-password"
        >
      
        <!-- SHOW/HIDE PASSWORD -->
        <f-p-input-show-hide-pass
          @togglePass="MX_togglePassVisibility('password')"
          :isHidden="MX_showHidePassword">
        </f-p-input-show-hide-pass>
      
        <img src="@/assets/images/validation_ico.png" alt="" class="icon">
      
        <div
          class="error-tooltip is-input-pass"
          v-show="errors.has('password')"
          :class="{'hide-tooltip' : bluredProp !== 'password'}"
        >
          <ul class="text">
            <li>{{$lang.messages.passMsgLabel}}:</li>
            <li>
              {{$lang.messages.passMsgLength}}
            </li>
            <li>
              {{$lang.messages.passMsgLowercase}}
            </li>
            <li>
              {{$lang.messages.passMsgNumber}}
            </li>
          </ul>
        </div>
      
      </div>
    
    <!-- REPEAT PASSWORD -->
    <p v-if="isRegister" class="input-filter-label">{{ $lang.messages.repeatPassword }}</p>
    <p v-else class="input-filter-label">{{ $lang.messages.repeatNewPassword }}</p>
    
    <div
      class="input-wrapper input-field"
      :class="{'error-input' : errors.has('repeatPassword')}"
    >
      <input
        type="password"
        name="repeatPassword"
        ref="repeatPassword"
        class="input"
        :placeholder="$lang.messages.repeatPassword"
        :value="repeatPasswordProp"
        v-validate="'required|confirmed:password'"
        @input="updateRepeatPass"
        @focus.self="clearInputErrorsPass"
        @blur="clearOthersPass"
        @keypress="MX_capsLockHandler($event)"
      >
    
      <!-- SHOW/HIDE REPEAT PASSWORD -->
      <f-p-input-show-hide-pass
        @togglePass="MX_togglePassVisibility('repeatPassword')"
        :isHidden="MX_showHideRepeatPass">
      </f-p-input-show-hide-pass>
    
      <img src="@/assets/images/validation_ico.png" alt="" class="icon">
    
      <div
        v-show="errors.has('repeatPassword')"
        class="error-tooltip"
        :class="{'hide-tooltip' : bluredProp !== 'repeatPassword'}"
      >
        <div class="text">
          {{ errors.first('repeatPassword') }}
        </div>
      </div>
    
    </div>

  </div>
</template>

<script>
  import { showHidePassword } from "@/mixins/showHidePassword";
  import { isCapsOn } from "@/mixins/isCapsOn";
  import FPInputShowHidePass from './FPInputShowHidePass';

  export default {
    name: "FPInputNewRepeatPass",
    inject: {
      $validator: '$validator'
    },
    components: {
      'f-p-input-show-hide-pass': FPInputShowHidePass
    },
    mixins: [
      showHidePassword,
      isCapsOn
    ],
    props: {
      bluredProp: {
        type: String,
        required: true
      },
      passwordProp: {
        type: String,
        required: true
      },
      repeatPasswordProp: {
        type: String,
        required: true
      },
      isRegister: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      // Emit a value to parent > LandingLayout
      updatePass (e) {
        this.$emit('updatePass', e.target.value);
        this.$emit('isCapsOn', this.MX_isCapsLockOn);
      },
      // Emit a value to parent > LandingLayout
      updateRepeatPass (e) {
        this.$emit('updateRepeatPass', e.target.value);
        this.$emit('isCapsOn', this.MX_isCapsLockOn);
      },
      // Remove error from currently selected field,
      // and remove tooltip on parent ( bluredPropChild )
      clearInputErrorsPass (e) {
        this.errors.remove(e.target.name)
        this.$emit('clearBluredFromChild')
      },
      // Emits a value to parent > LandingLayout
      clearOthersPass (e) {
        this.$emit('clearOthersPass', e)
      }
    }
  }
</script>

